import React from 'react';
import HotelMapModalProvider from '@/app/components/hotel-detail/HotelMapModalProvider';
import { OffersProvider } from '@/app/components/hotel-detail/OffersProvider';
import SessionProvider from '@/app/components/hotel-detail/SessionProvider';
import InitialParamsProvider, { type InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import { PageStatusProvider } from '@/app/components/hotel-detail/PageStatusProvider';
import TransportNotAvailableProvider from '@/app/components/hotel-detail/flight-train/TransportNotAvailableProvider';
import { CurrentFilterStatusProvider } from '@/app/components/hotel-detail/CurrentFilterStatusProvider';
import { SelectedMealPlanProvider } from '@/app/components/hotel-detail/SelectedMealPlanProvider';
import { UrlSearchParamsProvider } from './UrlSearchParamsProvider';
import { CuriosityProvider } from './CuriosityProvider';

type PageProvidersProps = {
  initialParams: InitialParams;
} & React.HTMLAttributes<HTMLElement>;

/** PageProviders is an abstraction of all the providers needed for the TO and HO page.
 *
 * Use the PageProviders component at the top layer of the page and the nested components will have access to the data provided by each of the providers.
 *
 New Providers can be added to the PageProviders and each page will automatically be able to tap into the added data. */
export function PageProviders(props: PageProvidersProps) {
  const { children, initialParams } = props;

  return (
    <InitialParamsProvider {...initialParams}>
      <UrlSearchParamsProvider>
        <HotelMapModalProvider>
          <SessionProvider>
            <CuriosityProvider>
              <PageStatusProvider>
                <OffersProvider>
                  <SelectedMealPlanProvider>
                    <TransportNotAvailableProvider>
                      <CurrentFilterStatusProvider>{children}</CurrentFilterStatusProvider>
                    </TransportNotAvailableProvider>
                  </SelectedMealPlanProvider>
                </OffersProvider>
              </PageStatusProvider>
            </CuriosityProvider>
          </SessionProvider>
        </HotelMapModalProvider>
      </UrlSearchParamsProvider>
    </InitialParamsProvider>
  );
}
